import * as actions from './discussion.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { DiscussionModel } from '@smarttask-common/src/lib/models/Discussion/Core/DiscussionModel';

export const discussionAdapter = createEntityAdapter<DiscussionModel>({
    selectId: (x) => x.discussion_id,
});
export interface DiscussionState extends EntityState<DiscussionModel> {
    selected_discussion_id: string;
}

export const initialState: DiscussionState = discussionAdapter.getInitialState({
    selected_discussion_id: undefined,
});

export function DiscussionReducers(
    state: DiscussionState = initialState,
    action: actions.DiscussionActions
) {
    switch (action.type) {
        case actions.DiscussionActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_discussion_id: action.selected_discussion_id };
            //console.log(state);
            return state;

        case actions.DiscussionActionTypes.ADD_DISCUSSION:
            return discussionAdapter.addOne(action.discussion, state);

        case actions.DiscussionActionTypes.ADD_DISCUSSIONS:
            return discussionAdapter.addMany(action.discussions, state);

        case actions.DiscussionActionTypes.UPSERT_DISCUSSION:
            return discussionAdapter.upsertOne(action.discussion, state);

        case actions.DiscussionActionTypes.UPSERT_DISCUSSIONS:
            return discussionAdapter.upsertMany(action.discussions, state);

        case actions.DiscussionActionTypes.UPDATE_DISCUSSION:
            return discussionAdapter.updateOne(action.discussion, state);

        case actions.DiscussionActionTypes.UPDATE_DISCUSSIONS:
            return discussionAdapter.updateMany(action.discussions, state);

        case actions.DiscussionActionTypes.DELETE_DISCUSSION:
            // if(state.selectedDiscussionId == action.id){
            //   state.selectedDiscussionId = undefined;
            // }
            return discussionAdapter.removeOne(action.id, state);

        case actions.DiscussionActionTypes.DELETE_DISCUSSIONS:
            // if(action.ids.indexOf(state.selectedDiscussionId) > -1){
            //   state.selectedDiscussionId = undefined;
            // }
            return discussionAdapter.removeMany(action.ids, state);

        case actions.DiscussionActionTypes.DELETE_ALL_DISCUSSIONS:
            return discussionAdapter.removeMany(action.ids, state);

        case actions.DiscussionActionTypes.DELETE_ALL:
            return discussionAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getDiscussionState = createFeatureSelector<DiscussionState>('discussion');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    discussionAdapter.getSelectors(getDiscussionState);

const getSelectedDiscussionIdState = (state: DiscussionState) => {
    return state.selected_discussion_id;
};
export const getSelectedDiscussionId = createSelector(getDiscussionState, getSelectedDiscussionIdState);

export const getSelectedDiscussion = createSelector(getDiscussionState, (state: DiscussionState) => {
    if (state.selected_discussion_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_discussion_id];
});
